<template>
  <section class="global-footprint" :class="{ 'is-zh': currentLanguage === 'ZH' }" aria-labelledby="global-footprint-title">
    <div class="global-footprint__inner">
      <header class="global-footprint__heading">
        <h2 id="global-footprint-title">{{ copy.title }}</h2>
        <p>{{ copy.subtitle }}</p>
      </header>
      <picture class="global-footprint__map">
        <source media="(max-width: 768px)" srcset="/static/images/footprint/world-hex-mobile.svg">
        <img src="/static/images/footprint/world-hex-desktop.svg" :alt="copy.mapAlt" width="1312" height="653.273" loading="lazy" decoding="async">
      </picture>
      <dl v-if="hasVerifiedMetrics" class="global-footprint__metrics">
        <div v-for="(metric, index) in metrics" :key="metric.id" :class="{ 'is-accent': metric.id === 'countries' }">
          <dt>{{ copy.labels[index] }}</dt>
          <dd>{{ metric.value }}</dd>
        </div>
      </dl>
    </div>
  </section>
</template>

<script>
const { siteLanguageMixin } = require('@/utils/site-language.js')
const { FOOTPRINT_METRICS, getFootprintCopy } = require('@/data/global-footprint.cjs')

export default {
  name: 'GlobalFootprint',
  mixins: [siteLanguageMixin],
  computed: {
    copy() { return getFootprintCopy(this.currentLanguage) },
    metrics() { return FOOTPRINT_METRICS },
    hasVerifiedMetrics() { return this.metrics.every(metric => metric.value && metric.source) }
  }
}
</script>

<style scoped>
.global-footprint, .global-footprint * { box-sizing: border-box; }
.global-footprint { width: 100%; padding: 80px 64px; color: #1d1d1f; background: #fff; font-family: 'MiSans-Regular', 'Segoe UI', sans-serif; }
.global-footprint__inner { display: flex; width: 100%; max-width: 1312px; margin: 0 auto; flex-direction: column; gap: 32px; }
.global-footprint__heading { display: flex; flex-direction: column; gap: 12px; text-align: center; }
.global-footprint__heading h2 { margin: 0; color: #1d1d1f; font-family: 'MiSans-Bold', 'Segoe UI', sans-serif; font-size: 30px; font-weight: 700; line-height: 44px; text-transform: none; }
.global-footprint__heading p { margin: 0; color: #6e6e73; font-size: 14px; line-height: 20px; }
.global-footprint__map { position: relative; display: block; width: 100%; aspect-ratio: 1312 / 640; }
.global-footprint__map img { position: absolute; top: 50%; left: 50%; display: block; width: 100%; height: auto; transform: translate(-50%, -50%); }
.global-footprint__metrics { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 24px; margin: 0; padding: 0; text-align: center; }
.global-footprint__metrics > div { display: flex; min-width: 0; flex-direction: column; gap: 8px; }
.global-footprint__metrics dt { order: 2; color: #6e6e73; font-size: 14px; font-weight: 400; line-height: 20px; }
.global-footprint__metrics dd { margin: 0; color: #1d1d1f; font-family: 'MiSans-Bold', 'Segoe UI', sans-serif; font-size: 44px; font-weight: 700; line-height: 53px; }
.global-footprint__metrics .is-accent dd { color: #ef0a6a; }
@media (max-width: 1199px) {
  .global-footprint { padding-right: 32px; padding-left: 32px; }
}
@media (max-width: 768px) {
  .global-footprint { padding: 40px 24px; }
  .global-footprint__inner { gap: 24px; }
  .global-footprint__heading { gap: 8px; }
  .global-footprint__heading h2 { font-size: 26px; line-height: 38px; }
  .global-footprint__map { aspect-ratio: 384 / 191.202; }
  .is-zh .global-footprint__map { aspect-ratio: 2; }
  .global-footprint__metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px 16px; }
  .global-footprint__metrics dt { font-size: 12px; line-height: 17px; }
  .global-footprint__metrics dd { font-size: 32px; line-height: 38px; }
  .is-zh .global-footprint__metrics dd { font-size: 26px; line-height: 31px; }
}
</style>
